// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ABvW","actionsCol":"EnrolledClinics_actionsCol__IxnhN"};